<template>
  <div class="start-page">
    <div class="start-page__body">
      <h2>START Page</h2>
      <ul>
        <li>
          <a href="/parents">Parent</a>
        </li>
        <li>
          <a href="/admin">Admin</a>
        </li>
        <li>
          <a href="/department">Department</a>
        </li>
        <li>
          <a href="/municipality">Municipality</a>
        </li>
        <li>
          <a href="/superadmin">Superadmin</a>
        </li>
        <li>
          <a href="/teachers">Teacher</a>
        </li>
        <li>
          <a href="/ui-esh">UI-ESH</a>
        </li>
        <li>
          <a href="/ui-esh-parent">UI-ESH-PARENT</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'index'
}
</script>

<style lang="scss" scoped>
.start-page {
  display: flex;
  justify-content: center;
  &__body {
    min-width: 400px;
    margin-top: 70px;
    background: rgba(0, 0, 0, 0.06);
    padding: 20px;
    border-radius: 5px;
    font-size: 16px;
    box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.22);
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      line-height: 2;
    }
  }
}
</style>